import axios from 'axios';
import {notification, message} from 'antd';
// data type
import {IconType} from 'antd/lib/notification/index';
import { log_out } from "../../../components/top-navbar/top-navbar";

axios.defaults.headers['Response-Type'] = 'json';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Cache'] = false;
axios.defaults.headers['Cache-Control'] = 'no-cache';
// axios.defaults.headers['Authorization'] = `Bearer ${cookies.get('EIToken')}`;

let status_401: boolean = true;

export function getPopupNode (){
    return document.getElementById('scroll-body') || document.body;
}
export function getPopupNodeModal (node: any){
    return node? node.parentNode : document.body
}

export function get_domain() {
    const hostname: string = window.location.hostname;
    const domain: string = hostname.slice(hostname.indexOf('.'));
    return {path: '/', domain: domain, maxAge: 3600}
}

export function get_router(props: any, ssoRole: string){
    const {pathname} = props.location;
    switch (pathname) {
        case '/': return ssoRole === 'globalAdmin'? 'overview': 'instanceList';
        case '/instance-list': return 'instanceList';
        case '/create-secret': return 'secretManagement';
        case '/resource/view': return 'overview';
        case '/resource/service': return 'serviceManagement';
        default: return 'null';
    }
}

// 格式化All URL
export function format_url(list: object[]) {
    const new_items: any = {};
    list?.map((item: any) => {
        const key: string = Object.keys(item)[0],
            value: object = item[key],
            service: any = Object.values(value as object)[0];
       return new_items[key] = {
            externalUrl: service.externalAddress,
            internalUrl: service.internalAddress,
            targetPort: service.targetPort
        }
    });
    return new_items;
}

// 格式化时间
export function format_time(date: any){
    const time = new Date(date);
    const year = time.toLocaleDateString(),
        hours = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours(),
        minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes(),
        seconds = time.getSeconds() < 10 ? `0${time.getSeconds()}` : time.getSeconds();
    return `${year} ${hours}:${minutes}:${seconds}`;
}

// 页面跳转
export function router_link(props: any, link: string, query?: any){
    props.history.push({pathname: link, query: query});
}

// 提示框
export function alert(type: IconType, title?: string, msg?: string) {
    // type: success, info, warning, error
    notification[type]({
        message: title,
        description: msg
    })
}

// loading
export function loading_alert(content: string){
    return message.loading(content, 0)
}

let loading: any = [];
let loading_action: any;

export function loading_alert_toggle() {
    if(loading.length === 1 ) {
        if (loading[0] === 'show_loading') {
            loading_action = message.loading('', 0)
        }
        if (loading[0] === 'hide_loading') {
            loading_action();
            loading = [];
            // const ele: any = document.getElementById('loading-app-content');
            // if(ele){
            //     setTimeout(()=>{
            //         ele.className='remove';
            //     }, 1000);
            //     setTimeout(()=>{
            //         ele.remove();
            //     }, 1500);
            // }
        }
    }
}

export function loading_alert_before(){
    if(loading.length<= 0){
        loading=['show_loading']
    }else {
        loading.unshift(1);
    }
    loading_alert_toggle();
}

export function loading_alert_after(){
    if(loading.length <= 1){
        loading =['hide_loading'];
    }else {
        loading.pop()
    }
    loading_alert_toggle()
}

export function user_selected_content_sidebar (list: any, set_fun: any){
    const session_selected : string | null =sessionStorage.getItem('content_sidebar_selected');
    let new_selected: string | undefined | null;
    if(session_selected){
        for(let i = 0; i< list.length; i++){
            if(list[i].key === session_selected){
                new_selected = list[i].key
            }else if(i === list.length-1){
                new_selected = list[0].key
            }
        }
    }else {
        new_selected = list[0].key
    }
    setTimeout(()=>set_fun(new_selected),100);
    return new_selected;
}

export function random_uuid (){
    const UUIDv4: string= '0123456789abcdef';
    let random_UUID: string ='';
    for (let i=0; i<32; i++){
        const random: number = Math.floor(Math.random()*16);
        i%4 === 0 && i/4>=2 && i/4<=5 && (random_UUID += '-');
        random_UUID += UUIDv4.slice(random, random+1);
    }
    return random_UUID;
}

export function http_error(des: any, props: any) {
    if(des&&des.response){
        const {data, status, statusText} = des.response;
        const { message, reason, description} = data;
        // const {formatMessage} = props;
        switch (status){
            case 401:
                if(status_401) {
                    status_401 = false;
                    // 其他portal401不给出提示框，暂时去掉
                    // alert('error', reason || 'Notification', message || description || statusText);
                }
                log_out({props, env: undefined, history: props.history, redirect_url: "/login/sign-in"})
                // log_out(props);
                status_401 = true;
                // const {href, hostname} = window.location;
                // setTimeout(async ()=>{
                //     const {items} = (await http_get(`/ecm/v1/public/config`, props) as any || {data:{services:{items:[]}}})?.data?.services || {items: []};
                //     if (items.length) {
                //         const local: string = hostname.slice(hostname.indexOf('.')),
                //             catalog_url : string = format_url(items)['portal-catalog'].externalUrl;
                //             if(catalog_url){
                //                 const catalog_hostname: string = catalog_url.slice(catalog_url.indexOf('.'));
                //                 (local === catalog_hostname) && window.open(`${catalog_url}/login?redirectUrl=${href}&portal=service`, '_self');
                //                 status_401 = true;
                //             }
                //     }
                // }, 2400);
                break;
            default: alert('error', reason || 'Notification', message || description || statusText); break;
        }
    }
}

// get
export const http_get = async (url: string, props: any) => {
    try {
        const res = await axios.get(url);
        return new Promise(resolve => resolve(res))
    } catch (err) {
        http_error(err, props)
    }
};

// post 请求
export const http_post = async (url: string, data: any, props: any) => {
    try {
        const res = await axios.post(url, JSON.stringify(data));
        return new Promise(resolve => {
            resolve(res)
        })
    } catch (err) {
        http_error(err, props)
    }
};

// put 请求
export const http_put = async (url: string, data: any, props: any) => {
    try {
        const res = data? await axios.put(url, JSON.stringify(data)): await axios.put(url);
        return new Promise(resolve => {
            resolve(res)
        })
    } catch (err) {
        http_error(err, props)
    }
};

// delete 请求
export const http_delete = async (url: string, data: any, props: any) => {
    try {
        const res = data? await axios.delete(url, {data: JSON.stringify(data)}): await axios.delete(url);
        return new Promise(resolve => {
            resolve(res);
        })
    } catch (err) {
        http_error(err, props)
    }
};

export const http_patch = async (url: string, data: any, props: any, header?: any) => {
    try {
        const res = data? await axios.patch(url, JSON.stringify(data), {headers: header || {}}): await axios.patch(url);
        return new Promise(resolve => {
            resolve(res);
        })
    } catch (err) {
        http_error(err, props)
    }
};
